import React from 'react'
import { makeStyles } from '@material-ui/styles'
import UserEventFile from './UserEventFile'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexFlow: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    backgroundColor: '#fff',
    borderRadius: '1rem',
  },
  fileWrapper: {
    width: '100%',
  },
  filesWrapper: {
    width: '100%',
    display: 'flex',
    flexFlow: 'row',
    flexWrap: 'wrap',
    justifyContent: 'start',
    margin: '40px 50px',
    '@media (max-width: 900px)': {
      flexFlow: 'column',
      alignItems: 'center',
    },
  },
  perFile: {
    marginRight: '50px',
    '@media (max-width: 900px)': {
      marginRight: '0',
    },
  },
}))

const UserEventFiles = ({ attachments }) => {
  const classes = useStyles()

  const imageFiles = attachments?.filter((item) => item?.mimeType === 'image/png' || item?.mimeType === 'image/jpeg')
  const videoFiles = attachments?.filter((item) => item?.mimeType === 'video/mp4')
  const audioFiles = attachments?.filter((item) => item?.mimeType === 'audio/mpeg')
  const pdfFiles = attachments?.filter((item) => item?.mimeType === 'application/pdf')

  return (
    <div className={classes?.root}>

      {/* Image Files */}
      {imageFiles?.length ? (
        <div className={classes.filesWrapper}>
          {imageFiles?.map((file) => (
            <div key={file?.url} className={classes.perFile}>
              <UserEventFile
                file={file}
              />
            </div>
          ))}
        </div>
      ) : null}

      {/* Video Files */}
      {videoFiles?.length ? (
        <div className={classes.filesWrapper}>
          {videoFiles?.map((file) => (
            <div key={file?.url} className={classes.perFile}>
              <UserEventFile
                file={file}
              />
            </div>
          ))}
        </div>
      ) : null}

      {/* Audio Files */}
      {audioFiles?.length ? (
        <div className={classes.filesWrapper}>
          {audioFiles?.map((file) => (
            <div key={file?.url} className={classes.perFile}>
              <UserEventFile
                file={file}
              />
            </div>
          ))}
        </div>
      ) : null}

      {/* PDF Files */}
      {pdfFiles?.length ? (
        <div className={classes.filesWrapper}>
          {pdfFiles?.map((file) => (
            <div key={file?.url} className={classes.perFile}>
              <UserEventFile
                file={file}
              />
            </div>
          ))}
        </div>
      ) : null}
    </div>
  )
}

export default UserEventFiles
